export default __webpack_public_path__ + "static/media/1_4.0b2d8d65.png";